module.exports = __webpack_public_path__ + "img/9 filters-07.f28dbbc2.svg";